import { CSSProperties } from 'react'
import { Table, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

interface OwnProps {
  subtitle: string
  style: CSSProperties
  title: string
}

type Props = OwnProps

export const ProfileCell = (props: Props) => (
  <Table.Cell style={{ ...props.style }}>
    <Text variant={TypographyStyles.LABEL_MD}>{props.title}</Text>
    <Text variant={TypographyStyles.BODY_SM}>{props.subtitle}</Text>
  </Table.Cell>
)
